export class OccupancyGenerateCriteria {
    minimumOccupancy: number;
    maximumOccupancy: number;
    minAdultsRequired: number;
}
